module.exports = __webpack_public_path__ + "static/media/bg-houseedf6b0c7af7d37572b979a09993b7c3b.webp";